import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalStorageService } from "ngx-store";
import { ConnoteSite } from "../model/dispatch.model";
import { Page } from "../model/pagination";
import { Url } from "../model/users.model";

/**
 * Dedicated injectable service for managing connote sites.
 */
@Injectable({
  providedIn: 'root'
})
export class ConnoteSiteService {
  private domain: Url = this.storage.get('url');

  public readonly endpoint = `${this.domain.rest}/tms/connote-sites`;

  public constructor(
    private storage: LocalStorageService,
    private client: HttpClient
  ) { }

  public get<T extends ConnoteSite>(options?: ConnoteSiteFetchOptions) {
    const params = toHttpParams(options);
    
    return this.client.get<Page<T>>(this.endpoint, { params });
  }
}

/**
 * Convert applicatoin fetch options to HTTP parameters.
 * 
 * @param options Fetch optinos.
 * @returns HTTP query parameters.
 */
const toHttpParams = (options?: ConnoteSiteFetchOptions) => {
  let params = new HttpParams();
  
  if(options?.includes?.length > 0) {
    params = params.set('include', options.includes.join(','));
  }

  if(options?.filters) {
    Object.entries(options.filters).forEach(([key, value]) => {
      params = params.set(key, `${value}`);
    });
  }

  if(options?.per_page) {
    params = params.set('per_page', `${options.per_page}`);
  }

  return params;
};

export interface ConnoteSiteFetchOptions {
  includes?: RelatedModel[],
  filters?: Record<string, number | string | boolean>;
  per_page?: number;
}

type RelatedModel = 'runPlanActivitiesCount' | 'location' | 'runAction';
